class ColorDotSelector extends HTMLElement {
  constructor() {
    super();

    // Ensure the container exists
    this.container = this.querySelector(".color-dots__container");
    this.body = document.querySelector("body");
    this.colorush = false;
    if (!this.container) {
      console.error("Error: Color dots container not found!");
      return;
    }

    this.init();
  }

  /**
   * Initialize event listeners
   */
  init() {
    this.container.addEventListener("change", (event) => {
      if (event.target.type === "radio" && event.target.name === "color-dot") {
        // this.body.classList.add("loading");
        this.handleSelection(event.target);
      }
    });
  }

  getVariantsByHandle(handle) {
    fetch('/products/' + handle + '.js')
    .then(function(response) {
      return response.json();
    })
    .then(function(product) {

      curProdroduct = {
        product_id: product.id,
        handle: product.handle,
        title: product.title,
        selected_variant_id: product.variants[0].id,
        variants: {}
      };

      product.variants.forEach(function(variant) {
        var title = variant.title.toLowerCase();

        if (title.indexOf('colorush') !== -1 && !curProdroduct.variants.colorush) {
          curProdroduct.variants.colorush = variant.price / 100;
        }

        else if (title.indexOf('pro') !== -1 && !curProdroduct.variants.pro) {
          curProdroduct.variants.pro = variant.price / 100;
        }

        else if (title.indexOf('original') !== -1 && !curProdroduct.variants.original) {
          curProdroduct.variants.original = variant.price / 100;
        }
      });
    })
    .catch(function(error) {
      console.log(error);
    });
  }

  /**
   * Handle the radio button selection
   * @param {HTMLElement} selectedRadio - Selected radio button element
   */
  async handleSelection(selectedRadio) {
    const productHandle = selectedRadio.getAttribute("data-product-handle");
    const productColorush = selectedRadio.getAttribute("data-product-colorush");
    this.colorush = JSON.parse(productColorush);

    if (!productHandle) {
      console.error("Error: Product handle not found!");
      return;
    }

    //this.getVariantsByHandle(productHandle);

    try {
      // const producttt = await this.fetchProductSection(productHandle);
      let sectionHTML = productData[productHandle];
      this.updateProductSection(sectionHTML, productHandle);

const existingStyle = document.getElementById('product-handle-style');

if (existingStyle) {
  existingStyle.remove();
}

const style = document.createElement('style');
style.id = 'product-handle-style';

if (
  productHandle === 'talon-translucent-smoke-rose-slate-polarized'
) {
  style.innerHTML = `
    .price-container.has-no-style:after {
      display: none !important;
    }
  `;
} else if (
  productHandle === 'azalea-galaxy-tortoise'
) {
  style.innerHTML = `
    .sr-lens-tier-fieldset:after {
      display: none !important;
    }
  `;
} else {
  style.innerHTML = `
    .price-container.has-no-style:after,
    .sr-lens-tier-fieldset:after {
      display: block !important;
    }
  `;
}

document.head.appendChild(style);
      const isLens = productColorush === true || productColorush === 'true';

        if (isLens) {
          document.querySelectorAll('.show-lens-col-section').forEach(el => {
            el.style.setProperty('display', 'block', 'important');
          });

          document.querySelectorAll('.hide-lens-col-section').forEach(el => {
            el.style.setProperty('display', 'block', 'important');
          });
        } else {
          document.querySelectorAll('.show-lens-col-section').forEach(el => {
            el.style.setProperty('display', 'none', 'important');
          });

          document.querySelectorAll('.hide-lens-col-section').forEach(el => {
            el.style.setProperty('display', 'none', 'important');
          });
        }
      setTimeout(function(){
        if (typeof yotpoWidgetsContainer !== 'undefined') {
          yotpoWidgetsContainer.initWidgets();
        }
        if(window.WishlistPlusPDPButtonAPI){
          window.WishlistPlusPDPButtonAPI.initializePDPButton(_swat)
        }
        _swat.initializeActionButtons("body")
        window.initQuickAddButtons();
        window.updateCADShippingText();
        
      }, 2000);
 
      function applyGlobalBasePriceAdjustments() {
        document.querySelectorAll('.product-form [data-product-collections] .money').forEach((element) => {
          const productWrapper = element.closest('[data-product-collections]');
          if (!productWrapper) return;
          if (
            productWrapper.dataset.discountedPrice !== undefined ||
            element.closest('[data-markdown-discounted="true"]') ||
            element.getAttribute('data-markdown-discounted') === 'true' ||
            (
              element.closest('[data-current]') &&
              !['original', 'default-title','original-standard','original-small'].includes(element.closest('[data-current]').dataset.current.toLowerCase())
            )
          ) {
            return;
          }
    
          const collections = productWrapper.dataset.productCollections
            ? productWrapper.dataset.productCollections.split(' ')
            : [];
    
          const variantTitle = productWrapper.dataset.current
            ? productWrapper.dataset.current.toLowerCase()
            : '';
    
          const priceText = element.textContent;
          const curr = theme.globals.userCurrency === 'GBP' ? '£' : '$';
    
          let prices = priceText.match(/[-+]?[0-9]*\.?[0-9]+/g);
          if (!prices) prices = [];
    
          let price_value = parseFloat(prices[0] || 0);
    
       
        });
      }

      setTimeout(() => {
        applyGlobalBasePriceAdjustments();
        if(MarkdownPricePro){
              MarkdownPricePro.run();
        }
      }, 2000);
    } catch (error) {
      console.error("Error updating product section:", error);
    }
  }
 
  /**
   * Fetch product section HTML
   * @param {string} productHandle - Handle of the selected product
   * @returns {Promise<string>} - Section HTML
   */
  async fetchProductSection(productHandle) {
    const apiEndpoint = `/products/${productHandle}`;
    const response = await fetch(apiEndpoint);

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }
    return response.text();
  }

  /**
   * Update the product section in the DOM
   * @param {string} html - HTML content of the product section
   * @param {string} productHandle - Product handle for the new URL
   */
  updateProductSection(html, productHandle) {
      
    setTimeout(() => this.updateTitanBanner(productHandle), 500);
              
    const handleToClassMap = {
      "oakmont-elite-good-good": "gg-oakmont",
      //"apex-elite-good-good": "gg-apex",
      //"classic-elite-good-good": "gg-classic"
    };
    
    const targetClass = handleToClassMap[productHandle];
    const allGGClasses = ["gg-oakmont"]; //["gg-oakmont", "gg-apex"];
    
    allGGClasses.forEach(ggClass => {
      const elements = document.querySelectorAll(`.${ggClass}.banner-gg`);
      elements.forEach(el => {
        if (ggClass === targetClass) {
          el.classList.remove("hidden");
          el.style.setProperty("display", "block", "important");
        } else {
          el.classList.add("hidden");
          el.style.setProperty("display", "none", "important");
        }
      });
    });
    
    const new_content = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector("product-form");

    if (!new_content) {
      console.error("Error: Product form not found in the response!");
      return;
    }

    const productBanner = document.querySelector(".section-image-with-text-overlay");
    const current_form = document.querySelector('product-form');

    if (current_form) {
      setTimeout(() => {
        const el = new_content.querySelector('.green-wolf-pdp');
        if (el) {
          el.style.opacity = '1';
        }
        current_form.replaceWith(new_content);

        document.dispatchEvent(new CustomEvent('product:color-dot:change', {
          detail: {
            productHandle: productHandle
          },
        }));
        const newVariantPicker = document.querySelector('variant-picker');
        if (newVariantPicker && typeof newVariantPicker.reinitialize === 'function') {
          newVariantPicker.reinitialize();
        }

        // Check the hunger free backpack count
        const bc_counter_pdp_qb =
          document.querySelector(".backpack-count-pdp");

        let bc_data_qb;

        try {
          bc_data_qb = JSON.parse(Cookies.get("backpack_count"));
        } catch (e) {
          bc_data_qb = null;
        }

        if (!bc_counter_pdp_qb) return;


          const count = Number(bc_data_qb?.count) || Math.floor(10000 + Math.random() * 90000);

          const formattedCount = count.toLocaleString("en-US");

          bc_counter_pdp_qb.textContent =
            count > 9 ? `${formattedCount}+` : formattedCount;

      }, 10);
      var rows = new_content.querySelectorAll('.hardcase-summary-row');
    const colorushBadge = new_content.querySelector('.sr-colorush');
    const proBadge = new_content.querySelector('.sr-pro');

    if (colorushBadge) colorushBadge.classList.add('hidden');
    if (proBadge) proBadge.classList.add('hidden');

    const styleFieldset = new_content.querySelector('.sr-lens-tier-fieldset');
    if (styleFieldset) {
      const styleInputs = styleFieldset.querySelectorAll('input[type="radio"]');

      if (styleInputs.length === 1) {
        const value = (styleInputs[0].value || '').toLowerCase();

        if (value.includes('colorush') && colorushBadge) {
          colorushBadge.classList.remove('hidden');
        }

        if (value.includes('pro') && proBadge) {
          proBadge.classList.remove('hidden');
        }
      }
    }

      rows.forEach(function (row) {
        row.addEventListener('click', function (e) {
    
          var wrapper = row.closest('.hardcase');
          var btn = row.querySelector('.hardcase-toggle-btn');
          var content = wrapper ? wrapper.querySelector('.hardcase-content') : null;
    
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', String(!isOpen));
          content.hidden = isOpen;
          wrapper.classList.toggle('is-open', !isOpen);
        });
      });
      if (productBanner) {
        productBanner.style.display = this.colorush ? "block" : "none";
      }
      // Replace (not push) the current history entry when switching color dots.
      // The PDP keeps a single history entry no matter how many dots are clicked,
      // so the browser Back button returns to the page the shopper came from
      // (e.g. the collection page) instead of stepping through each color.
      history.replaceState(history.state, "", `/products/${productHandle}`);
     
      setTimeout(function() {
        function addcollectionimage() {
          const grid = document.querySelector('.product-media-collage.desktop-only');
          const variantSelector = document.querySelectorAll('[data-option-name="style"]');  
      
          const createImageElement = (mediaId, imageUrl) => `
              <div class="product-media-collage__item" data-media-id="${mediaId}">
                  <a class="show-gallery" href="${imageUrl}&width=5000" aria-label="View larger image">
                      <div class="product-media-wrapper" data-media-id="${mediaId}" tabindex="-1">
                          <div class="product-media product-media--image">
                              <img src="${imageUrl}" alt="${mediaId.indexOf('lb-') === 0 ? 'Lens benefits' : 'Product feature highlights'}" width="1280" height="960"
                              sizes="(min-width: 1600px) 800px, (min-width: 768px) 50vw, 100vw" 
                              srcset="${imageUrl}" class="theme-img">
                          </div>
                      </div>
                  </a>
              </div>
          `;
      
          const createThumbElement = (mediaId, imageUrl) => {
              const a = document.createElement("a");
              a.className = "gallery-viewer__thumb";
              a.setAttribute("href", "#");
              a.setAttribute("data-media-id", mediaId);
              a.setAttribute("data-zoom-url", `${imageUrl}&width=5000`);
              a.setAttribute("aria-label", "View image: " + (mediaId.indexOf('lb-') === 0 ? 'Lens benefits' : 'Product feature highlights'));
              const img = document.createElement("img");
              img.className = "gallery-viewer__thumb-img";
              img.setAttribute("src", `${imageUrl}&width=138`);
              img.setAttribute("alt", "");
              img.setAttribute("width", "138");
              img.setAttribute("height", "92");
              a.appendChild(img);
              return a;
          };
          if (typeof collectionImages !== 'undefined') {
            if (collectionImages[collectionType]) {
                const mediaId = collectionType;
                const imageUrl = collectionImages[mediaId];
                const mainImageDiv = document.createElement("div");
                mainImageDiv.innerHTML = createImageElement(mediaId, imageUrl);
                if(grid){
                  grid.insertBefore(mainImageDiv.firstElementChild, grid.children[3] || null);
                }
                const observer = new MutationObserver((mutations, obs) => {
                    const thumbs = document.querySelector('.modal[open] .gallery-viewer__thumbs');
                    if (thumbs) {
                        const thumbElement = createThumbElement(mediaId, imageUrl);
                        const thumbChildren = thumbs.children;
                        thumbs.insertBefore(thumbElement, thumbChildren[3]);
                        obs.disconnect();
                    }
                });
        
                observer.observe(document.body, { childList: true, subtree: true });
            }
          }
          let additionalImageType = null;
          if (["classics","talon","cayman","cascade","capitan","huron", "navigator", "x series","signature series","apex","rival","forgedallure","reign","nitro","safety","highrise","signatureseries","titan"].includes(collectionType)) {
              additionalImageType = "lb-men";
          } else if (["allure","aviator","oakmont","lynx","mojave","cypress","aviatorcrossover"].includes(collectionType)) {
              additionalImageType = "lb-women";
          } else if (["srfish-caymanelite", "srfish-capitanelite", "srfish-talonelite"].includes(collectionType)) {
              additionalImageType = "lb-fish";
          } else if (["srgolf-classicelite", "srgolf-apexelite","srgolf-oakmontelite","srgolf-titanelite"].includes(collectionType)) {
              additionalImageType = "lb-golf";
          }
          if (typeof pro_handle !== 'undefined') {
            if (pro_handle.includes("tangle")) {
                const videoUrl = "https://cdn.shopify.com/videos/c/o/v/f5e3676a64b84157b5980c4448aaf662.mp4";
                const videoHTML = `
                    <div class="product-media-collage__item" data-media-id="tangle-video">
                            <div class="product-media-wrapper" data-media-id="tangle-video" tabindex="-1">
                                <div class="product-media product-media--video">
                                    <video autoplay loop muted controls playsinline width="100%" height="auto">
                                        <source src="${videoUrl}" type="video/mp4">
                                    </video>
                                </div>
                            </div>
                    </div>
                `;
                const videoElement = document.createElement("div");
                videoElement.innerHTML = videoHTML;
                if(grid){
                grid.appendChild(videoElement.firstElementChild);
                }

            }
          }
      
          if (additionalImageType && collectionImages[additionalImageType]) {
              const imageUrl = collectionImages[additionalImageType];
              const additionalImageDiv = document.createElement("div");
              additionalImageDiv.innerHTML = createImageElement(additionalImageType, imageUrl);
              if(grid){
              grid.appendChild(additionalImageDiv.firstElementChild);
              }
      
              const observer = new MutationObserver((mutations, obs) => {
                  const thumbs = document.querySelector('.modal[open] .gallery-viewer__thumbs');
                  if (thumbs) {
                      thumbs.appendChild(createThumbElement(additionalImageType, imageUrl));
                      obs.disconnect();
                  }
              });
      
              observer.observe(document.body, { childList: true, subtree: true });
          }
      
          const updateVariantImages = (selectedVariant) => {
              const isColorush = selectedVariant.includes("colorush");
              const mediaIdToAdd = isColorush ? "cr-variant" : "non-cr-variant";
              const mediaIdToRemove = isColorush ? "non-cr-variant" : "cr-variant";
              const imageUrl = collectionImages[mediaIdToAdd];
          
              if (!imageUrl) return;
      
              document.querySelectorAll(`[data-media-id="${mediaIdToRemove}"]`).forEach(el => el.remove());
              document.querySelectorAll(`[data-media-id="${mediaIdToAdd}"]`).forEach(el => el.remove());

    
              const variantImageDiv = document.createElement("div");
              variantImageDiv.innerHTML = createImageElement(mediaIdToAdd, imageUrl);
              if(grid){
              grid.insertBefore(variantImageDiv.firstElementChild, grid.lastElementChild);
              }
              document.querySelectorAll('.show-gallery').forEach(link => {
                link.style.pointerEvents = 'auto';
              });
              const observer = new MutationObserver((mutations, obs) => {
                  const thumbs = document.querySelector('.modal[open] .gallery-viewer__thumbs');
                  if (thumbs) {
                      const thumbElement = createThumbElement(mediaIdToAdd, imageUrl);
                      document.querySelectorAll(`.gallery-viewer__thumb[data-media-id="${mediaIdToRemove}"]`).forEach(el => el.remove());
                      document.querySelectorAll(`.gallery-viewer__thumb[data-media-id="${mediaIdToAdd}"]`).forEach(el => el.remove());
                      thumbs.insertBefore(thumbElement, thumbs.lastElementChild);
                      document.querySelectorAll('.show-gallery').forEach(link => {
                        link.style.pointerEvents = 'auto';
                      });
                      obs.disconnect();
                  }
              });
              
      
              observer.observe(document.body, { childList: true, subtree: true });
          };
      
          const has_colorush = Array.from(variantSelector).some(option => option.value.toLowerCase() === "colorush");
          if (has_colorush && collectionImages[collectionType]) {
              variantSelector.forEach(option => {
                  option.addEventListener("change", function () {
                      updateVariantImages(this.value.toLowerCase());
                      document.querySelectorAll('.show-gallery').forEach(link => {
                        link.style.pointerEvents = 'auto';
                      });
                  });
                  if (option.checked) {
                      updateVariantImages(option.value.toLowerCase());
                      document.querySelectorAll('.show-gallery').forEach(link => {
                        link.style.pointerEvents = 'auto';
                      });
                  }
              });
          }
          document.querySelectorAll('.show-gallery').forEach(link => {
            link.style.pointerEvents = 'auto';
          });
      }
      // if (document.body.classList.contains("show-pdp-gallery")) {
        addcollectionimage();
      // }
      function setCookie(name, value) {
        document.cookie = `${name}=${value}; path=/; max-age=${48 * 60 * 60}`;
      }
      function getCookie(name) {
        const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
        return match ? match[2] : null;
      }
      if(document.body.classList.contains('white-bg-golf')){
        setCookie("feature", "green-wolf");
        const bodyClass = [...document.body.classList].find(cls => cls.startsWith('feature-'));
        const activeFeature = bodyClass?.replace('feature-', '') || getCookie("feature") ;
        // const activeFeature = "green-wolf";
        // var title = collectionTitle.toLowerCase().replace(/\s+/g, '-');
        if (activeFeature) {
          setCookie("feature", activeFeature);
          if(activeFeature == 'green-wolf') {
            document.querySelector('.shop-men')?.classList.remove("hidden");
            const sku = document.querySelector('.green-wolf-pdp').getAttribute('data-pdp-gf');
            const baseURL = 'https://shady-rays.s3.us-east-2.amazonaws.com/assets/golf-white-images';
          
            // Create image URLs directly
            const imageUrls = [];
            for (let index = 1; index <= 4; index++) {
              imageUrls.push(`${baseURL}/${sku}/${String(index).padStart(2, '0')}.png`);
            }
              function updateProductImagesFromSKU() { 
                updateProductImages(imageUrls);
                observeGalleryThumbs(imageUrls);
              }
              
              function updateProductImages(imageUrls) {
                const maxImages = imageUrls.length;
              

              
              }
              function replaceGalleryViewerThumbs(imageUrls) {
                const openModal = document.querySelector('modal-dialog[open]');
                if (!openModal) return;
              
                const thumbsContainers = openModal.querySelectorAll('.gallery-viewer__thumbs');
                const maxImages = imageUrls.length;
              
                thumbsContainers.forEach(container => {
                  const thumbs = container.querySelectorAll('.gallery-viewer__thumb');
              
                  thumbs.forEach((thumb, index) => {
                    if (index < maxImages) {
                      thumb.setAttribute('data-zoom-url', imageUrls[index]);
                      const img = thumb.querySelector('img');
                      if (img) {
                        img.src = imageUrls[index];
                        img.srcset = `${imageUrls[index]} 138w`;
                      }
                    } 
                    // else {
                    //   thumb.remove();
                    // }
                  });
                });
              }
              
              function observeGalleryThumbs(imageUrls) {
                const observer = new MutationObserver((mutations, obs) => {
                  const openModal = document.querySelector('modal-dialog[open]');
              
                  if (openModal && openModal.querySelector('.gallery-viewer__thumbs')) {
                    replaceGalleryViewerThumbs(imageUrls);
                    obs.disconnect();
                  }
                });
              
                observer.observe(document.body, { childList: true, subtree: true });
              }
              function generateSrcset(url) {
                const baseUrl = url.split('?')[0];
                const version = url.split('?')[1] || '';
                const widths = [425, 600, 925, 1225, 1500, 1750, 2000, 2400, 2500];
                return widths.map(w => `${baseUrl}?${version}&width=${w} ${w}w`).join(', ');
              }
              
              updateProductImagesFromSKU();
              // setTimeout(() => {
                const el = document.querySelector('.green-wolf-pdp');
                if (el) {
                el.style.opacity = '1';
                }
              // }, 1000);


          }
           
        }  else {
            const el = document.querySelector('.green-wolf-pdp');
            if (el) {
            el.style.opacity = '1';
            }
        }
      }

      }, 700);
      setTimeout(initCustomSwymNotifyButton, 2500);
    } else {
      console.error("Error: Product form container not found in the document!");
    }
  }

  updateTitanBanner(productHandle) {
    const isTitan = productHandle.includes('titan-elite-');
    const isClassic = productHandle.includes('classic-elite-');
    const isApex = productHandle.includes('apex-elite-');

    if (!isTitan && !isClassic && !isApex) return;

    const showOnly = (showSelectors = [], hideSelectors = []) => {
      showSelectors.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
          el.classList.remove('hidden');
          el.style.setProperty("display", "block", "important");
        });
      });

      hideSelectors.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
          el.classList.add('hidden');
          el.style.setProperty("display", "none", "important");
        });
      });
    };

    if(isTitan) {
      if (productHandle === 'titan-elite-theegala-glacier') {
        showOnly(
          ['.sahith-blue.banner-sahith', '.sahith-signature', '.cls-titan-sahith'],
          ['.sahith-black.banner-sahith', '.cls-titan-elite']
        );
      } else if (productHandle === 'titan-elite-theegala-tortoise') {
        showOnly(
          ['.sahith-black.banner-sahith', '.sahith-signature', '.cls-titan-sahith'],
          ['.sahith-blue.banner-sahith', '.cls-titan-elite']
        );
      } else {
        showOnly(
          ['.sahith-blue.banner-sahith', '.cls-titan-elite'],
          ['.sahith-black.banner-sahith', '.sahith-signature', '.cls-titan-sahith']
        );
      }
    }
    
    if(isClassic) {
      if (productHandle === 'classic-elite-good-good') {
        showOnly(
          ['.cls-classic-good'],
          ['.cls-classic-elite']
        );
      } else {
        showOnly(
          ['.cls-classic-elite'],
          ['.cls-classic-good']
        );
      }
    }

    if(isApex) {
      if (productHandle === 'apex-elite-good-good') {
        showOnly(
          ['.cls-apex-good'],
          ['.cls-apex-elite']
        );
      } else {
        showOnly(
          ['.cls-apex-elite'],
          ['.cls-apex-good']
        );
      }
    }
    
  }

  updateProductOptions() {
  }
}


// Define the custom element
customElements.define("color-dot-selector", ColorDotSelector);

document.addEventListener('DOMContentLoaded', function () {
  const btn_coming_soon = document.querySelector('.btn-coming-soon');
  if (btn_coming_soon) {
    btn_coming_soon.innerHTML = `Coming Soon`;
  }
  document.querySelector('product-form .add-to-cart').setAttribute('disabled', 'disabled');
  document.querySelector('product-form .add-to-cart').disabled = true;

  setTimeout(function(){
    document.querySelector('product-form .add-to-cart').removeAttribute('disabled');
    document.querySelector('product-form .add-to-cart').disabled = false;
  }, 1000);
});

document.addEventListener('click', function (e) {
  const trigger = e.target.closest(
    'product-form .price-container .yotpo-sr-bottom-line-summary'
  );

  if (!trigger) return;

  const scrollToReviews = () => {
    const target = document.getElementById('yotpo-app');
    if (!target) return false;

    const headerOffset = 100;
    const top =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      headerOffset;

    window.scrollTo({
      top: top,
      behavior: 'smooth',
    });

    return true;
  };

  // Try immediately
  if (!scrollToReviews()) {
    const interval = setInterval(() => {
      if (scrollToReviews()) clearInterval(interval);
    }, 200);
  }
});

function initCustomSwymNotifyButton() {
  try {
    const form = document.querySelector('product-form');

    const soldOutBtn = form.querySelector('button[name="add"][disabled]');

    // If Swym app already injected its own Notify button and it's visible,
    // remove our custom button (if exists) and stop execution
    const swymInjectedBtn = form.querySelector(
      '.swym-button.swym-notify-btn, .swym-added-to-waitlist, .swym-button-bar button'
    );

    if (swymInjectedBtn) {
      const style = window.getComputedStyle(swymInjectedBtn);
      const isVisible =
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        swymInjectedBtn.offsetParent !== null;

      if (isVisible) {
        const existingCustom = form.querySelector('.custom-swym-notify');
        if (existingCustom) existingCustom.remove();
        return;
      }
    }

    if (soldOutBtn) {
      if (form.querySelector('.custom-swym-notify')) return;

      const container = form.querySelector('.quantity-submit-row') || soldOutBtn.parentElement;
      if (!container) return;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'btn btn--large custom-swym-notify';
      btn.innerText = 'Notify Me When Available';
      btn.style.marginTop = '10px';

      container.appendChild(btn);

      btn.addEventListener('click', function () {
        try {
          if (typeof _swat === 'undefined') {
            console.warn('SWYM not loaded');
            return;
          }

          const variantId = form.querySelector('input[name="id"]')?.value;
          const productId = form.querySelector('input[name="product-id"]')?.value;
          const productUrl = window.location.href;
          const productImg = document.querySelector('.product-media img')?.src || '';

          const priceText = document.querySelector('.price .money')?.textContent || '0';
          const priceValue = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;

          let product = {
            epi: Number(variantId),
            empi: Number(productId),
            du: productUrl,
            iu: productImg,
            pr: priceValue,
            et: 8
          };

          let topic = 'comingsoon';
          let onSuccess = function(response){ console.log('SWYM popup opened', response); };

          _swat.addToWatchList(null, product, onSuccess, null, topic);
        } catch (e) {
          console.error('SWYM notify error', e);
        }
      });
    }
  } catch (e) {
    console.error('Notify button init failed', e);
  }
}
